"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _triangle = _interopRequireDefault(require("cccisd-icons/triangle2"));
var _cccisdDataviz = _interopRequireDefault(require("cccisd-dataviz"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _chunk2 = _interopRequireDefault(require("lodash/chunk"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MAIN_CHART = 'Main';
var POS_CHART = 'Positive';
var SUMMARY_CHART = 'Summary';
var SUMMARY_CHART_POS = 'Positive Summary';
var INDIVIDUAL_CHART = 'Individual';
var INDIVIDUAL_CHART_POS = 'Positive Individual';
var issueText = 'issues';
var positiveIssueText = 'positiveIssues';
// const issueValueText = 'issuesValues';
var ProgressReport = /*#__PURE__*/function (_Component) {
  _inherits(ProgressReport, _Component);
  function ProgressReport() {
    var _this;
    _classCallCheck(this, ProgressReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProgressReport, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentView: SUMMARY_CHART,
      currentViewPos: SUMMARY_CHART_POS,
      hiddenView: INDIVIDUAL_CHART,
      hiddenViewPos: INDIVIDUAL_CHART_POS,
      issues: [],
      positiveIssues: []
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._getAllIssues();
    });
    _defineProperty(_assertThisInitialized(_this), "_getAllIssues", function () {
      var masterIssuesList = [];
      var masterPositiveIssueList = [];
      _this.props.sessions.forEach(function (session) {
        (0, _forEach2["default"])(session[issueText], function (issue) {
          if (!masterIssuesList.includes(issue)) {
            masterIssuesList.push(issue);
          }
        });
        (0, _forEach2["default"])(session[positiveIssueText], function (posIssue) {
          if (!masterPositiveIssueList.includes(posIssue)) {
            masterPositiveIssueList.push(posIssue);
          }
        });
      });
      _this.setState({
        issues: masterIssuesList,
        positiveIssues: masterPositiveIssueList
      });
    });
    // toggle current view for Severity Components section
    _defineProperty(_assertThisInitialized(_this), "_toggleView", function () {
      var hold = _this.state.currentView;
      _this.setState({
        currentView: _this.state.hiddenView,
        hiddenView: hold
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_toggleViewPos", function () {
      var hold = _this.state.currentViewPos;
      _this.setState({
        currentViewPos: _this.state.hiddenViewPos,
        hiddenViewPos: hold
      });
    });
    // render charts by view type
    _defineProperty(_assertThisInitialized(_this), "_renderIndividualIssues", function (viewType) {
      var isReport = _this.props.isReport;
      var listType = viewType === SUMMARY_CHART ? _style["default"].horzList : _style["default"].vertList;
      var triangleOrientation = _this.state.currentView === SUMMARY_CHART ? _style["default"].arrowUp : _style["default"].arrowDown;
      var results = [];
      if (_this.state.issues.length > 3) {
        var newArray = (0, _chunk2["default"])(_this.state.issues, 3);
        newArray.forEach(function (array, index) {
          var isFirst = (0, _first2["default"])(newArray) === array;
          var html = /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].reportWrapper
          }, isReport && _this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].reportContentWrapper
          }, isFirst && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].detailsHeader
          }, /*#__PURE__*/_react["default"].createElement("h1", null, "Individual ", _this.props.reportProps.negativeGraphLabel), /*#__PURE__*/_react["default"].createElement("a", {
            onClick: _this._toggleView.bind(null)
          }, "See ", _this.state.hiddenView, " View", ' ', /*#__PURE__*/_react["default"].createElement("span", {
            className: triangleOrientation
          }, /*#__PURE__*/_react["default"].createElement(_triangle["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].detailsContent
          }, _this._renderChartList(array, viewType)))));
          results.push(html);
        });
        return results;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportWrapper
      }, isReport && _this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsHeader
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Individual ", _this.props.reportProps.negativeGraphLabel), /*#__PURE__*/_react["default"].createElement("a", {
        onClick: _this._toggleView.bind(null)
      }, "See ", _this.state.hiddenView, " View", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: triangleOrientation
      }, /*#__PURE__*/_react["default"].createElement(_triangle["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsContent
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: listType
      }, _this.state.issues.map(function (issue, index) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: index
        }, _this._renderListItem(viewType, issue));
      }))))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderChartList", function (array, viewType) {
      var listType = viewType === SUMMARY_CHART ? _style["default"].horzList : _style["default"].vertList;
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: listType
      }, array.map(function (issue, index) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: index
        }, _this._renderListItem(viewType, issue));
      }));
    });
    // render charts by view type
    _defineProperty(_assertThisInitialized(_this), "_renderIndividualIssuesPos", function (viewType) {
      var listType = viewType === SUMMARY_CHART_POS ? _style["default"].horzList : _style["default"].vertList;
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: listType
      }, _this.state.positiveIssues.map(function (issue, index) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: index
        }, _this._renderListItem(viewType, issue));
      }));
    });
    // render the individual summary chart
    _defineProperty(_assertThisInitialized(_this), "_renderListItem", function (viewType, chartName) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, chartName), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: _this._getChartObject(viewType, chartName),
        allowEdit: false
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "populateNulls", function (num) {
      var array = [];
      for (var i = 0; i < num; i++) {
        array.push(null);
      }
      return array;
    });
    _defineProperty(_assertThisInitialized(_this), "_populateInitialTable", function (table, issueLabel, chartLabel) {
      if ('targetLineValue1' in _this.props.reportProps && 'targetLineValue2' in _this.props.reportProps) {
        if (chartLabel) {
          var match = (0, _find2["default"])(_this.state.positiveIssues, function (issue) {
            return issue === chartLabel;
          });
          if (match) {
            table.push(['Session', 'BASELINE1', 'BASELINE2', match]);
            table.push([0, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2, null], [11, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2, null]);
          } else {
            console.error('Chart label does not exist in the issues list');
          }
        } else {
          table.push(['Session', 'BASELINE1', 'BASELINE2'].concat(_this.state["".concat(issueLabel, "s")]));
          table.push([0, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2].concat(_this.populateNulls(_this.state["".concat(issueLabel, "s")].length)));
          table.push([11, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2].concat(_this.populateNulls(_this.state["".concat(issueLabel, "s")].length)));
        }
      } else if ('targetLineValue1' in _this.props.reportProps) {
        table.push(['Session', 'BASELINE1'].concat(_this.state["".concat(issueLabel, "s")]));
        table.push([0, _this.props.reportProps.targetLineValue1].concat(_this.populateNulls(_this.state["".concat(issueLabel, "s")].length)));
      } else {
        table.push(['Session'].concat(_this.state["".concat(issueLabel, "s")]));
        table.push([0].concat(_this.populateNulls(_this.state["".concat(issueLabel, "s")].length)));
        table.push([11].concat(_this.populateNulls(_this.state["".concat(issueLabel, "s")].length)));
      }
      return table;
    });
    _defineProperty(_assertThisInitialized(_this), "_populateInitialRow", function (session) {
      var row;
      if ('targetLineValue1' in _this.props.reportProps && 'targetLineValue2' in _this.props.reportProps) {
        row = [+session.xAxisLabel, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2];
      } else if ('targetLineValue1' in _this.props.reportProps) {
        row = [+session.xAxisLabel, _this.props.reportProps.targetLineValue1];
      } else {
        row = [+session.xAxisLabel];
      }
      return row;
    });
    _defineProperty(_assertThisInitialized(_this), "_populateTable", function (table, issueLabel) {
      var initialTable = _this._populateInitialTable((0, _cloneDeep2["default"])(table), issueLabel);
      _this.props.sessions.forEach(function (session) {
        var row = _this._populateInitialRow(session);
        _this.state["".concat(issueLabel, "s")].forEach(function (issue) {
          if ((0, _has2["default"])(session, "".concat(issueLabel, "s")) && session["".concat(issueLabel, "s")].length) {
            var indexOfIssue = (0, _findIndex2["default"])(session["".concat(issueLabel, "s")], function (i) {
              return i === issue;
            });
            if (indexOfIssue !== -1) {
              row.push(+session["".concat(issueLabel, "Values")][indexOfIssue]);
            } else {
              row.push(null);
            }
          } else {
            row.push(null);
          }
        });
        initialTable.push(row);
      });
      return initialTable;
    });
    _defineProperty(_assertThisInitialized(_this), "_getTableForIssues", function (chartType) {
      var individualIssue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var table = [];
      if (chartType === 'MAIN') {
        table = _this._populateTable(table, 'issue');
      }
      if (chartType === 'POSITIVE') {
        table = _this._populateTable(table, 'positiveIssue');
      }
      if (chartType === 'SUMMARY') {
        table.push(['Session', individualIssue]);
        table.push([0, null]);
        table.push([11, null]);
        _this.props.sessions.forEach(function (session) {
          var row = [+session.xAxisLabel];
          if ('issues' in session && session.issues.length) {
            var indexOfIssue = (0, _findIndex2["default"])(session.issues, function (i) {
              return i === individualIssue;
            });
            if (indexOfIssue !== -1) {
              row.push(parseInt(session.issueValues[indexOfIssue], 10));
            } else {
              row.push(null);
            }
          } else {
            row.push(null);
          }
          table.push(row);
        });
      }
      if (chartType === 'INDIVIDUAL') {
        if ('targetLineValue1' in _this.props.reportProps && 'targetLineValue2' in _this.props.reportProps) {
          table.push(['Session', 'BASELINE1', 'BASELINE2', individualIssue]);
          table.push([0, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2, null]);
          table.push([11, _this.props.reportProps.targetLineValue1, _this.props.reportProps.targetLineValue2, null]);
        } else if ('targetLineValue1' in _this.props.reportProps) {
          table.push(['Session', 'BASELINE1', individualIssue]);
          table.push([0, _this.props.reportProps.targetLineValue1, null]);
        } else {
          table.push(['Session', individualIssue]);
          table.push([0, null]);
        }
        _this.props.sessions.forEach(function (session) {
          var row = _this._populateInitialRow(session);
          if ('issues' in session && session.issues.length) {
            var indexOfIssue = (0, _findIndex2["default"])(session.issues, function (i) {
              return i === individualIssue;
            });
            if (indexOfIssue !== -1) {
              row.push(+session.issueValues[indexOfIssue]);
            } else {
              row.push(null);
            }
          } else {
            row.push(null);
          }
          table.push(row);
        });
      }
      if (chartType === 'SUMMARY_POSITIVE') {
        table.push(['Session', individualIssue]);
        table.push([0, null]);
        table.push([11, null]);
        _this.props.sessions.forEach(function (session) {
          var row = [parseInt(session.xAxisLabel, 10)];
          if ('positiveIssues' in session && session.positiveIssues.length) {
            var indexOfIssue = (0, _findIndex2["default"])(session.positiveIssues, function (i) {
              return i === individualIssue;
            });
            if (indexOfIssue !== -1) {
              row.push(parseInt(session.positiveIssueValues[indexOfIssue], 10));
            } else {
              row.push(null);
            }
          } else {
            row.push(null);
          }
          table.push(row);
        });
      }
      if (chartType === 'INDIVIDUAL_POSITIVE') {
        table = _this._populateInitialTable(table, 'positiveIssue', individualIssue);
        _this.props.sessions.forEach(function (session) {
          var row = _this._populateInitialRow(session);
          if ('positiveIssues' in session && session.positiveIssues.length) {
            var indexOfIssue = (0, _findIndex2["default"])(session.positiveIssues, function (i) {
              return i === individualIssue;
            });
            if (indexOfIssue !== -1) {
              row.push(parseInt(session.positiveIssueValues[indexOfIssue], 10));
            } else {
              row.push(null);
            }
          } else {
            row.push(null);
          }
          table.push(row);
        });
      }
      return table;
    });
    // get chart data and type
    _defineProperty(_assertThisInitialized(_this), "_getChartObject", function (optionsType, individualSeries) {
      var dataTableObj = [];
      switch (optionsType) {
        case MAIN_CHART:
          dataTableObj = _this._getTableForIssues('MAIN');
          break;
        case POS_CHART:
          dataTableObj = _this._getTableForIssues('POSITIVE');
          break;
        case SUMMARY_CHART:
          dataTableObj = _this._getTableForIssues('SUMMARY', individualSeries);
          break;
        case INDIVIDUAL_CHART:
          dataTableObj = _this._getTableForIssues('INDIVIDUAL', individualSeries);
          break;
        case SUMMARY_CHART_POS:
          dataTableObj = _this._getTableForIssues('SUMMARY_POSITIVE', individualSeries);
          break;
        case INDIVIDUAL_CHART_POS:
          dataTableObj = _this._getTableForIssues('INDIVIDUAL_POSITIVE', individualSeries);
          break;
        default:
          break;
      }
      return {
        chartType: 'LineChart',
        dataTable: dataTableObj,
        options: _this._getLineChartOptions(optionsType, individualSeries)
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getVericalScale", function () {
      var verticalTicks = [];
      var min = +_this.props.reportProps.verticalScaleMin;
      var max = +_this.props.reportProps.verticalScaleMax;
      var interval = +_this.props.reportProps.verticalScaleInterval;
      if (!interval) {
        if (max <= 5) {
          interval = 1;
        } else if (max < 25 && max > 5) {
          interval = 2;
        } else if (max >= 25 && max < 50) {
          interval = 5;
        } else if (max >= 50 && max < 90) {
          interval = 10;
        } else if (max > 90) {
          interval = 20;
        }
      }
      for (var i = min; i <= max;) {
        verticalTicks.push(i);
        i += interval;
      }
      return verticalTicks;
    });
    _defineProperty(_assertThisInitialized(_this), "_getSeriesForIssues", function () {
      var isSummary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var series = {};
      if ('targetLineValue1' in _this.props.reportProps) {
        series[0] = {
          color: '#D3E3CB',
          tooltip: false,
          enableInteractivity: false,
          visibleInLegend: false
        };
      } else {
        series[0] = Object.assign({
          pointSize: isSummary ? 3 : 6
        }, isSummary && {
          color: '#D3E3CB'
        });
      }
      if ('targetLineValue2' in _this.props.reportProps) {
        series[1] = {
          color: '#D3E3CB',
          tooltip: false,
          enableInteractivity: false,
          visibleInLegend: false
        };
      } else {
        series[1] = Object.assign({
          pointSize: isSummary ? 3 : 6
        }, isSummary && {
          color: '#D3E3CB'
        });
      }
      _this.state.issues.forEach(function (issue, index) {
        series[index + 2] = {
          pointSize: 6
        };
      });
      return series;
    });
    _defineProperty(_assertThisInitialized(_this), "_getSeriesForIssuesPos", function () {
      var isSummary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var series = {};
      if ('targetLineValue1' in _this.props.reportProps) {
        series[0] = {
          color: '#D3E3CB',
          tooltip: false,
          enableInteractivity: false,
          visibleInLegend: false
        };
      } else {
        series[0] = Object.assign({
          pointSize: isSummary ? 3 : 6
        }, isSummary && {
          color: '#D3E3CB'
        });
      }
      if ('targetLineValue2' in _this.props.reportProps) {
        series[1] = {
          color: '#D3E3CB',
          tooltip: false,
          enableInteractivity: false,
          visibleInLegend: false
        };
      } else {
        series[1] = Object.assign({
          pointSize: isSummary ? 3 : 6
        }, isSummary && {
          color: '#D3E3CB'
        });
      }
      _this.state.positiveIssues.forEach(function (issue, index) {
        series[index + 2] = {
          pointSize: 6
        };
      });
      return series;
    });
    // get display options for chart based on passed in type
    _defineProperty(_assertThisInitialized(_this), "_getLineChartOptions", function (chartTypeToGet, individualSeries) {
      var vertTicks = _this._getVericalScale();
      switch (chartTypeToGet) {
        case MAIN_CHART:
          return {
            legend: {
              position: 'right'
            },
            width: 670,
            chartArea: {
              left: 50,
              width: '70%'
            },
            interpolateNulls: true,
            series: _this._getSeriesForIssues(),
            vAxis: {
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: vertTicks,
              title: _this.props.reportProps.yAxisLabel,
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks(),
              title: 'Session',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            }
          };
        case POS_CHART:
          return {
            legend: {
              position: 'right'
            },
            width: 670,
            chartArea: {
              left: 50,
              width: '70%'
            },
            interpolateNulls: true,
            series: _this._getSeriesForIssuesPos(),
            vAxis: {
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: vertTicks,
              title: _this.props.reportProps.yAxisLabelPos,
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks(),
              title: 'Session',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            }
          };
        case SUMMARY_CHART:
          return {
            legend: {
              position: 'none'
            },
            backgroundColor: 'transparent',
            width: 250,
            height: 75,
            interpolateNulls: true,
            series: _this._getSeriesForIssues(true),
            vAxis: {
              baselineColor: '#ccc',
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: [{
                v: 0,
                f: ''
              }, {
                v: 10,
                f: ''
              }]
            },
            hAxis: {
              baselineColor: '#ccc',
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks()
            }
          };
        case INDIVIDUAL_CHART:
          return {
            legend: {
              position: 'none'
            },
            width: 670,
            interpolateNulls: false,
            series: _this._getSeriesForIssues(),
            vAxis: {
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: vertTicks,
              title: 'Severity',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks(),
              title: 'Session',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            }
          };
        case SUMMARY_CHART_POS:
          return {
            legend: {
              position: 'none'
            },
            backgroundColor: 'transparent',
            width: 250,
            height: 75,
            interpolateNulls: true,
            series: _this._getSeriesForIssuesPos(true),
            vAxis: {
              baselineColor: '#ccc',
              gridlines: {
                color: 'transparent'
              },
              ticks: [{
                v: 0,
                f: ''
              }, {
                v: 10,
                f: ''
              }]
            },
            hAxis: {
              baselineColor: '#ccc',
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks()
            }
          };
        case INDIVIDUAL_CHART_POS:
          return {
            legend: {
              position: 'none'
            },
            width: 670,
            interpolateNulls: false,
            series: _this._getSeriesForIssuesPos(),
            vAxis: {
              gridlines: {
                color: '#D3D3D3'
              },
              minorGridlines: {
                color: 'transparent'
              },
              ticks: vertTicks,
              title: _this.props.reportProps.yAxisLabelPos,
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            },
            hAxis: {
              gridlines: {
                color: 'transparent'
              },
              ticks: _this._getHorzTicks(),
              title: 'Session',
              titleTextStyle: {
                color: '#999',
                italic: false
              }
            }
          };
        default:
          return {};
      }
    });
    // get the horizontal (x-axis) ticks for the charts
    _defineProperty(_assertThisInitialized(_this), "_getHorzTicks", function () {
      var sessions = _this.props.sessions;
      var ticksObj = [{
        v: 0,
        f: ''
      }, {
        v: 11,
        f: ''
      }];
      for (var x = 0; x < sessions.length; x++) {
        ticksObj.push(sessions[x].responseSet);
        // ticksObj.push({v: sessions[x].responseSet, f: sessions[x].xAxisLabel});
      }
      return ticksObj;
    });
    // replace breaking characters (space, hyphen) with non-breaking versions
    _defineProperty(_assertThisInitialized(_this), "_getNonbreakingString", function (breakingString) {
      return breakingString.replace(' ', "\xA0").replace('-', "\u2011");
    });
    return _this;
  }
  _createClass(ProgressReport, [{
    key: "render",
    value: function render() {
      var triangleOrientationPos = this.state.currentViewPos === SUMMARY_CHART_POS ? _style["default"].arrowUp : _style["default"].arrowDown;
      var isReport = this.props.isReport;
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      var hasPositiveSubtext = !(0, _isNil2["default"])(this.props.reportProps.positiveGraphDescription);
      var hasNegativeSubtext = !(0, _isNil2["default"])(this.props.reportProps.negativeGraphDescription);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportWrapper
      }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.reportProps.reportTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.reportProps.description), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h3", null, this.props.reportProps.negativeGraphLabel), hasNegativeSubtext ? /*#__PURE__*/_react["default"].createElement("p", null, this.props.reportProps.negativeGraphDescription) : /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          display: 'none'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mainChart
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: this._getChartObject(MAIN_CHART, ''),
        allowEdit: false
      }))))))), ('showPositiveChart' in this.props.reportProps && this.props.reportProps.showPositiveChart || !('showPositiveChart' in this.props.reportProps)) && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportWrapper
      }, isReport && this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("h3", null, this.props.reportProps.positiveGraphLabel), hasPositiveSubtext ? /*#__PURE__*/_react["default"].createElement("p", null, this.props.reportProps.positiveGraphDescription) : /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          display: 'none'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].chartContent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].mainChart
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDataviz["default"], {
        chartData: this._getChartObject(POS_CHART, ''),
        allowEdit: false
      }))))))), this.state.currentView === SUMMARY_CHART && this._renderIndividualIssues(SUMMARY_CHART), this.state.currentView === INDIVIDUAL_CHART && this._renderIndividualIssues(INDIVIDUAL_CHART), ('showPositiveChart' in this.props.reportProps && this.props.reportProps.showPositiveChart || !('showPositiveChart' in this.props.reportProps)) && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportWrapper
      }, isReport && this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsHeader
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Individual", ' ', this.props.reportProps.positiveGraphLabel), this.state.hiddenViewPos === SUMMARY_CHART_POS && /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this._toggleViewPos.bind(null)
      }, "See Summary View", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: triangleOrientationPos
      }, /*#__PURE__*/_react["default"].createElement(_triangle["default"], null))), this.state.hiddenViewPos === INDIVIDUAL_CHART_POS && /*#__PURE__*/_react["default"].createElement("a", {
        onClick: this._toggleViewPos.bind(null)
      }, "See Individual View", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: triangleOrientationPos
      }, /*#__PURE__*/_react["default"].createElement(_triangle["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].detailsContent
      }, this.state.currentViewPos === SUMMARY_CHART_POS && this._renderIndividualIssuesPos(SUMMARY_CHART_POS), this.state.currentViewPos === INDIVIDUAL_CHART_POS && this._renderIndividualIssuesPos(INDIVIDUAL_CHART_POS))))))));
    }
  }]);
  return ProgressReport;
}(_react.Component);
_defineProperty(ProgressReport, "defaultProps", {
  isReport: false
});
ProgressReport.propTypes = {
  /**
   * [
   *   {
   *      handle: "session1",
   *      axislabel: "1",
   *      date: moment(),
   *      held: true,
   *      completed: false,
   *      fidelityScore: 67,
   *      ComponentCoverageScore: 95,
   *      DeliveryQualityScore: 85,
   *      ComplianceScore: 75,
   *      Dosage: 90,
   *   },
   *   {
   *      handle: "session2",
   *      axislabel: "2",
   *      date: moment(),
   *      held: false,
   *      completed: false,
   *      fidelityScore: 92,
   *      ComponentCoverageScore: 65,
   *      DeliveryQualityScore: 90,
   *      ComplianceScore: 72,
   *      Dosage: 81
   *   },
   *   . . .
   * ]
   */
  sessions: _propTypes["default"].array,
  reportProps: _propTypes["default"].object,
  isReport: _propTypes["default"].bool,
  /**
   * Full rendered markup for the header
   */
  header: _propTypes["default"].node
};
var _default = exports["default"] = ProgressReport;